import { useAccount } from '@/hooks/useAccount';
import { webCampaign } from '@/modules/webCampaign';

import { MainImageStyles } from './MainImage.styles';

export const MainImage = () => {
  const { user } = useAccount();

  const getMainImageSrc = () => {
    if (
      webCampaign.setup.gender_ai_type === 'man' ||
      user?.onboarding_data.gender === 'male'
    ) {
      return '../assets/success-page/default/man/main.png';
    }

    return `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/${webCampaign.aiType}/main-success.png`;
  };

  return (
    <MainImageStyles>
      <img src={getMainImageSrc()} alt="AI" />
    </MainImageStyles>
  );
};
